import type {
    AnatomySampleMap
} from "../types";
import {
    MessageScroller,
    Attachment,
    Composer,
    Message,
    Bubble,
    Trace
} from "ncore-ui-kit";
import {
    shapeConfigs
} from "../sampleTokens";

const SAMPLE_SCROLLER_STYLE = {
    height: shapeConfigs.chartHeight.large
};

const createSampleTimestamp = () => {
    const timestamp = new Date();

    timestamp.setHours(14, 32, 0, 0);

    return timestamp;
};

const SAMPLE_TIMESTAMP = createSampleTimestamp();

export const chatSamples: AnatomySampleMap = {
    MessageScroller: (t) => ({
        node: <MessageScroller.Provider>
            <MessageScroller
                style={SAMPLE_SCROLLER_STYLE}
                title={t("sample.title")}
            >
                <MessageScroller.Viewport>
                    <MessageScroller.Content>
                        <MessageScroller.Item
                            messageId="first"
                        >
                            <Message>
                                <Bubble>
                                    {t("sample.message")}
                                </Bubble>
                            </Message>
                        </MessageScroller.Item>
                        <MessageScroller.Item
                            messageId="second"
                        >
                            <Message
                                align="end"
                            >
                                <Bubble
                                    variant="user"
                                >
                                    {t("sample.reply")}
                                </Bubble>
                            </Message>
                        </MessageScroller.Item>
                    </MessageScroller.Content>
                </MessageScroller.Viewport>
                <MessageScroller.Footer>
                    <Composer />
                </MessageScroller.Footer>
            </MessageScroller>
        </MessageScroller.Provider>,
        width: shapeConfigs.dialogMaxWidth,
        maxScale: 2
    }),
    Attachment: (t) => ({
        node: <Attachment
            description={t("sample.fileSize")}
            title={t("sample.fileName")}
            onRemove={() => undefined}
        />
    }),
    Composer: (t) => ({
        node: <Composer
            defaultValue={t("sample.reply")}
            onAttachPress={() => undefined}
        />,
        width: shapeConfigs.dialogMaxWidth,
        maxScale: 3
    }),
    Message: (t) => ({
        width: shapeConfigs.dialogMaxWidth,
        node: <Message
            timestamp={SAMPLE_TIMESTAMP}
            avatar={{
                title: t("sample.name")
            }}
            title={t("sample.name")}
        >
            <Bubble>
                {t("sample.message")}
            </Bubble>
        </Message>,
        maxScale: 3
    }),
    Trace: (t) => ({
        node: <Trace>
            <Trace.Reasoning
                text={t("sample.body")}
                isDefaultOpen={true}
                durationSeconds={12}
                status="done"
            />
            <Trace.ToolCall
                title={t("sample.action")}
                output={t("sample.code")}
                duration={1400}
                status="done"
            />
        </Trace>,
        maxScale: 3
    }),
    Bubble: (t) => ({
        width: shapeConfigs.drawerWidth,
        node: <Bubble.Group>
            <Bubble>
                {t("sample.message")}
            </Bubble>
        </Bubble.Group>,
        maxScale: 3
    })
};
